module.exports = __webpack_public_path__ + "img/H-63-ST-1200-BB.5eb468d8.png";